<template>
  <tooltip
    :text="tooltipContent"
    target=".tooltip-circle"
    :aria-label="tooltipContent"
  >
    <span
      class="tooltip-circle"
      tabindex="0"
    >
      <i class="fa fa-question-circle" />
    </span>
  </tooltip>
</template>

<script>
export default {
  name: 'StudentPiiTooltip',
  data() {
    return {
      tooltipContent: 'Goalbook discourages entering student personally identifiable information.'
    }
  }
}
</script>
